<mat-card class="config-panel">
  <mat-card-header>
    <mat-card-title>Default Config</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div class="controls">
      <mat-slide-toggle
        [(ngModel)]="showActionIcons"
        (ngModelChange)="onActionIconsChange()"
        [matTooltip]="showActionIcons ? 'Hide action icons below each file' : 'Show action icons below each file'"
        >Action Icons</mat-slide-toggle
      >
      <mat-slide-toggle
        [(ngModel)]="showPreviewAction"
        (ngModelChange)="updateConfig()"
        [matTooltip]="showPreviewAction ? 'Hide preview action button' : 'Show preview action button'"
        >Preview</mat-slide-toggle
      >
      <mat-slide-toggle
        [(ngModel)]="showDownloadAction"
        (ngModelChange)="updateConfig()"
        [matTooltip]="showDownloadAction ? 'Hide download action button' : 'Show download action button'"
        >Download</mat-slide-toggle
      >
      <mat-slide-toggle
        [(ngModel)]="showDeleteAction"
        (ngModelChange)="updateConfig()"
        [matTooltip]="showDeleteAction ? 'Hide delete action button' : 'Show delete action button'"
        >Delete</mat-slide-toggle
      >
      <mat-slide-toggle
        [(ngModel)]="generatePdfThumbnails"
        (ngModelChange)="onGeneratePdfThumbnailsChange()"
        [matTooltip]="generatePdfThumbnails ? 'Disable PDF thumbnail generation' : 'Enable PDF thumbnail generation'"
        >PDF Thumbnails</mat-slide-toggle
      >
      <mat-slide-toggle
        [(ngModel)]="generateDocxThumbnails"
        (ngModelChange)="onGenerateDocxThumbnailsChange()"
        [matTooltip]="generateDocxThumbnails ? 'Disable DOCX thumbnail generation' : 'Enable DOCX thumbnail generation'"
        >DOCX Thumbnails</mat-slide-toggle
      >
    </div>

    <div class="config-toggles">
      <div class="thumbnail-size-control">
        <label>Thumbnail Size:</label>
        <mat-button-toggle-group [(ngModel)]="thumbnailSize" (ngModelChange)="updateConfig()" aria-label="Thumbnail Size">
          <mat-button-toggle value="sm" matTooltip="Small thumbnail size">S</mat-button-toggle>
          <mat-button-toggle value="md" matTooltip="Medium thumbnail size">M</mat-button-toggle>
          <mat-button-toggle value="lg" matTooltip="Large thumbnail size">L</mat-button-toggle>
        </mat-button-toggle-group>
      </div>
    </div>
  </mat-card-content>
</mat-card>

<mad-file-upload
  [multiple]="true"
  [accept]="['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'svg', 'ico', 'pdf', 'docx', 'xlsx', 'xls', 'xlsm', 'xlsb', 'ods', 'csv']"
  [text]="'Upload Files'"
  [id]="'file-preview-upload'"
  (fileEmitter)="onFilesUploaded($event)"
/>

<mad-file-preview [items]="items" [config]="config" (deleteClicked)="onDeleteClicked($event)" />
